import React from 'react';
import { Brain, Loader2, X } from 'lucide-react';
import type { CopilotInitializeResponse } from '@/types/copilot';
import { Button } from '@/components/ui/button';

interface MCPCopilotHeaderProps {
  isInitializing: boolean;
  initError: string | null;
  copilotProfile: CopilotInitializeResponse | null;
  isLoading: boolean;
  onClose?: () => void;
}

export const MCPCopilotHeader: React.FC<MCPCopilotHeaderProps> = ({
  isInitializing,
  initError,
  copilotProfile,
  isLoading,
  onClose,
}) => {
  return (
    <div className="flex items-center justify-between p-4 border-b border-gray-200 bg-white">
      <div className="flex items-center gap-2">
        <Brain className="w-5 h-5 text-primary" />
        {isInitializing ? (
          <div className="flex items-center gap-2">
            <Loader2 className="w-4 h-4 text-gray-400 animate-spin" />
            <h3 className="font-semibold text-gray-500">Loading...</h3>
          </div>
        ) : initError ? (
          <h3 className="font-semibold text-red-600">Error loading copilot</h3>
        ) : copilotProfile ? (
          <div className="flex flex-col">
            <h3 className="font-semibold text-gray-900">{copilotProfile.copilot_profile.name}</h3>
            <p className="text-xs text-gray-500">{copilotProfile.copilot_profile.persona_name}</p>
          </div>
        ) : (
          <h3 className="font-semibold text-gray-900">AI Assistant</h3>
        )}
        {isLoading && (
          <div className="flex items-center space-x-1 ml-2">
            <div className="w-2 h-2 bg-primary rounded-full animate-bounce-dot"></div>
            <div className="w-2 h-2 bg-primary rounded-full animate-bounce-dot" style={{ animationDelay: '0.1s' }}></div>
            <div className="w-2 h-2 bg-primary rounded-full animate-bounce-dot" style={{ animationDelay: '0.2s' }}></div>
          </div>
        )}
      </div>
      {onClose && (
        <Button variant="ghost" size="sm" onClick={onClose}>
          <X className="w-4 h-4" />
        </Button>
      )}
    </div>
  );
};
